import moment from 'moment';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import TooltipItem from '../../common/Tooltip';
import { defaultDateFormat } from '../../common/constant';
import { messages } from '../../common/messages';
import App_data from '../../views/config/App_data';

export default class DateFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: '',
      endDate: '',
      tooltipOpen: false,
      formattedEndDate: '',
      formattedStartDate: '',
    };
  }
  async componentDidUpdate(prevProps, prevState) {
    const { formattedStartDate, formattedEndDate } = this.state;
    const { getUserBarGraph, getTotalUsersBarGraph, level = '' } = this.props;

    if (formattedStartDate && formattedEndDate && formattedEndDate !== prevState.formattedEndDate) {
      getUserBarGraph(formattedStartDate, formattedEndDate, level);
      getTotalUsersBarGraph(formattedStartDate, formattedEndDate, level);
    }
  }
  onHandleDateChange = async (date, name) => {
    const { startDate } = this.state;
    if (name === 'startDate') {
      this.setState({
        startDate: date,
        endDate: '',
        formattedEndDate: '',
        formattedStartDate: moment(date).format(defaultDateFormat),
      });
    } else {
      if (startDate !== '')
        this.setState({
          endDate: date,
          formattedEndDate: moment(date).format(defaultDateFormat),
        });
    }
  };

  onResetDate = () => {
    const { startDate, endDate } = this.state;
    const { getUserBarGraph, getTotalUsersBarGraph, level='' } = this.props;
    if (startDate && endDate) {
      this.setState(
        {
          startDate: '',
          endDate: '',
          formattedStartDate: '',
          formattedEndDate: '',
        },
        () => {
          const { formattedStartDate, formattedEndDate } = this.state;
          getUserBarGraph(formattedStartDate, formattedEndDate , level);
          getTotalUsersBarGraph(formattedStartDate, formattedEndDate, level);
          // this.getQuestionProgressBar(data);
        },
      );
    }
  };
  render() {
    const { startDate, endDate, tooltipOpen } = this.state;
    return (
      <div className='card margin_bottom_20'>
        <div className='card-block'>
          <div className='row dashboard-filter'>
            <div className='date-field align-self-center'>
              <div className='d-flex'>
                <div className='mr-1 min-width-35px text-md-right align-self-center'>
                  <label className='mb-0'>{messages.FROM}</label>
                </div>
                <div className='align-self-center w-100 pr-1'>
                  <div className='datepicker_wrap'>
                    <div className='ico_box'>
                      <img
                        src={`${App_data.frontend_url}/img/dashboard/calendar.svg`}
                        alt='startDateCalendar'
                        width='14'
                      />
                    </div>
                    <DatePicker
                      selected={startDate}
                      onChange={event => this.onHandleDateChange(event, 'startDate')}
                      placeholderText='Select date'
                      width='100%'
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='date-field align-self-center'>
              <div className='d-flex'>
                <div className='mr-1 min-width-35px text-md-center align-self-center'>
                  <label className='mb-0'> {messages.TO}</label>
                </div>
                <div className='align-self-center w-100 pr-1'>
                  <div className='datepicker_wrap'>
                    <div className='ico_box'>
                      <img
                        src={`${App_data.frontend_url}/img/dashboard/calendar.svg`}
                        alt='EndDateCalendar'
                        width='14'
                      />
                    </div>
                    <DatePicker
                      placeholderText='Select date'
                      width='100%'
                      selected={endDate}
                      minDate={startDate}
                      onChange={event => this.onHandleDateChange(event, 'endDate')}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='mx-auto text-md-center align-self-center'>
              <button
                type='button'
                aria-label='Reset date filter'
                className={`btn btn-circle btn-refresh cursor-pointer ${
                  !startDate || !endDate ? 'disabled' : ''
                }`}
                onClick={() => this.onResetDate()}
              >
                <i className='fa fa-refresh' aria-hidden='true' id='Tooltip-1' />

                <TooltipItem
                  key='1'
                  tooltipId='1'
                  content='Reset Date'
                  tooltipPlace='top'
                  tooltipOpen={tooltipOpen}
                  isTooltipIcon={false}
                />
                <span className='reset'>Reset</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/DateFilter.jsx